import _ from 'lodash'
import moment from 'moment'

class PotBurnCtrl {
    /** @ngInject */
    constructor($state, $q, $filter, User, Contract, PotManager, ErrorCatcher) {
        this.$state = $state
        this.$q = $q
        this.$filter = $filter
        this.User = User
        this.Contract = Contract
        this.PotManager = PotManager
        this.ErrorCatcher = ErrorCatcher
    }

    // INIT COMPONENT
    $onInit() {
        this.dispatch({ type: 'ON_INIT', pot: this.PotManager.getPotBalance() })

        // Fetch old potBurnConfirmed after state reload
        const potBurnConfirmed = JSON.parse(sessionStorage.getItem('potBurnConfirmed'))
        if (potBurnConfirmed && moment().isBefore(potBurnConfirmed.expire)) {
            this.dispatch(potBurnConfirmed)
        } else {
            this.User.getUa().$promise.then((userAction) => {
                return _.some(userAction, (action) => {
                    return (Number(action.type) === 100)
                        && (action.status === 0)
                        && (action.id_contract === this.userInfo.contractSelected.id)
                })
            }).then((isBurned) => {
                this.dispatch({ type: 'UPDATE_IS_BURNED', isBurned })
                this.dispatch({ type: 'DISPLAY_INITIAL_VIEW' })
            })
        }

        this.PotManager.watch((pot) => {
            this.dispatch({ type: 'UPDATE_POT', pot })

            // Reload view only on initial states - not the final state
            if (['state_initial_burnable', 'state_initial_not_burnable', 'state_initial'].indexOf(this.state) > -1) {
                this.dispatch({ type: 'DISPLAY_INITIAL_VIEW' })
            }
        })
    }

    // ACTIONS
    displayInitialView() {
        this.dispatch({ type: 'DISPLAY_INITIAL_VIEW' })
    }

    displaySelectBurnType() {
        this.dispatch({ type: this.canBurnInvestment ? 'SELECT_BURN_TYPE' : 'BURN_TO_BILL_CONFIRM' })
    }

    displayConfirmBurnToBill() {
        this.dispatch({ type: 'BURN_TO_BILL_CONFIRM' })
    }

    burnToBill() {
        this.dispatch({ type: 'BURN_TO_BILL_IN_PROGRESS' })
        const burnToBill$ = this.Contract.burnToBill({ id: this.userInfo.contractSelected.id }).$promise
        burnToBill$.then((response) => {
            // Save to sessionStorage before $state reload
            sessionStorage.setItem('potBurnConfirmed', JSON.stringify({
                type: 'BURN_TO_BILL_CONFIRMED',
                expire: moment().add(1, 'minutes').toISOString(),
            }))
            this.PotManager.update()
            this.$state.go(this.$state.current, {}, { reload: true })
        })
        burnToBill$.catch((error) => {
            this.ErrorCatcher.catchError(error)
            this.dispatch({ type: 'BURN_TO_BILL_ERROR', error })
        })
    }

    displayConfirmBurnInvestment() {
        this.dispatch({ type: 'BURN_INVESTMENT_CONFIRM' })
    }

    burnToInvestment() {
        this.dispatch({ type: 'BURN_INVESTMENT_IN_PROGRESS' })
        const potAmount = Number(this.selectedPotAmount.replace(',', '.'))
        const selectedAmount = (this.pot.real > potAmount) ? potAmount : this.pot.real
        const burnToInvestment$ = this.Contract.burnToInvestment({ amount: selectedAmount }).$promise
        burnToInvestment$.then((response) => {
            // Save to sessionStorage before $state reload
            sessionStorage.setItem('potBurnConfirmed', JSON.stringify({
                type: 'BURN_INVESTMENT_CONFIRMED',
                amountBurned: selectedAmount,
                economyKWA: response.economyKWA,
                ecomonyAmount: response.ecomonyAmount,
                expire: moment().add(1, 'minutes').toDate(),
            }))
            this.PotManager.update()
            this.$state.go(this.$state.current, {}, { reload: true })
        })
        burnToInvestment$.catch((error) => {
            this.ErrorCatcher.catchError(error)
            this.dispatch({ type: 'BURN_INVESTMENT_ERROR', error })
        })
    }

    // REDUCER
    dispatch(action = {}) {
        switch (action.type) {
            case 'ON_INIT':
                this.state = 'state_initial'
                this.isBurningPot = false
                this.burningError = null
                this.isBurned = undefined
                this.pot = action.pot
                this.potUsable = this.userInfo.contractSelected.contractBalance.balance >= 0
                this.BURN_INVESTMENT_THRESHOLD = 10
                this.canBurnInvestment = this.pot.real >= this.BURN_INVESTMENT_THRESHOLD
                this.amountBurned = null
                this.economyKWA = null
                this.ecomonyAmount = null
                this.selectedPotAmount = this.$filter('frAmount')(Math.max((this.pot.real / 2), this.BURN_INVESTMENT_THRESHOLD))
                break
            case 'UPDATE_IS_BURNED':
                this.isBurned = action.isBurned
                break
            case 'UPDATE_POT':
                this.pot = action.pot
                this.canBurnInvestment = this.pot.real >= this.BURN_INVESTMENT_THRESHOLD
                break
            case 'DISPLAY_INITIAL_VIEW':
                if (this.isBurned === true) {
                    this.state = 'state_burn_confirmed'
                } else if (this.isBurned === false && this.pot) {
                    this.state = this.pot.real > 0 ? 'state_initial_burnable' : 'state_initial_not_burnable'
                } else {
                    this.state = 'state_initial'
                }
                break
            case 'SELECT_BURN_TYPE':
                this.state = 'state_burn_type'
                break
            case 'BURN_TO_BILL_CONFIRM':
                this.state = 'state_confirm_burn'
                this.isBurningPot = false
                this.burningError = null
                break
            case 'BURN_TO_BILL_IN_PROGRESS':
                this.state = 'state_confirm_burn'
                this.isBurningPot = true
                this.burningError = null
                break
            case 'BURN_TO_BILL_CONFIRMED':
                this.state = 'state_burn_confirmed'
                this.isBurned = true
                this.isBurningPot = false
                this.burningError = null
                break
            case 'BURN_TO_BILL_ERROR':
                this.state = 'state_confirm_burn'
                this.isBurningPot = false
                this.burningError = action.error
                break
            case 'BURN_INVESTMENT_CONFIRM':
                this.state = 'state_confirm_burn_investment'
                this.isBurningPot = false
                this.burningError = null
                break
            case 'BURN_INVESTMENT_IN_PROGRESS':
                this.state = 'state_confirm_burn_investment'
                this.isBurningPot = true
                this.burningError = null
                break
            case 'BURN_INVESTMENT_CONFIRMED':
                this.state = 'state_burn_investment_confirmed'
                this.isBurned = true
                this.isBurningPot = false
                this.burningError = null
                this.amountBurned = action.amountBurned
                this.economyKWA = action.economyKWA
                this.ecomonyAmount = action.ecomonyAmount
                break
            case 'BURN_INVESTMENT_ERROR':
                this.state = 'state_confirm_burn_investment'
                this.isBurningPot = false
                this.burningError = action.error
                break
            default:
                break
        }
    }
}

export default {
    template: require('./potBurn.jade')(),
    controller: PotBurnCtrl,
    bindings: {
        userInfo: '<',
    },
}



// WEBPACK FOOTER //
// ./src/states/tracking/component/potBurn.js